import type { PortfolioQueryKeys } from './types';

/**
 * Query key factory utilities for TanStack Query
 *
 * Convention: [domain, ...identifiers, ...dependencies]
 * All keys must be deterministic and use primitive values only.
 */

export const portfolioQueryKeys: PortfolioQueryKeys = {
  byId: (params) => ['portfolio', params.tag, params.portfolioId, params.pkg, params.asOf],
};
